<template>
  <el-dialog
    title="功能授权配置"
    :visible.sync="isShow"
    @close="$emit('isShow', false)"
  >
    <!-- <span style="color:red;font-size:28px;">{{isShow}}</span> -->
    <!-- haveID:{{haveID}}
    propsKey:{{propsKey}} -->
    <el-tree
      :data="data"
      ref="tree"
      show-checkbox
      node-key="id"
      :default-checked-keys="propsKey"
      :props="defaultProps"
    ></el-tree>
    <div
      slot="footer"
      class="dialog-footer"
    >
      <el-button @click="close">取 消</el-button>
      <el-button
        type="primary"
        @click="sure(); "
      >确 定</el-button>
      .
    </div>
  </el-dialog>
</template>

<script>
import {
  Api_SuperAdmin,
  Api_System
} from "@/api/api";
export default {
  // isshow 是弹框的展示与隐藏；
  // propsKey 是已选节点；
  // setType是做的类型判断；
  // companyId 公司id
  // haveID 项目可配置的权限列表； 

  props: ['isShow', 'propsKey', 'setType', 'companyId', 'haveID'],
  data() {
    return {
      data: [],
      defaultProps: {
        label: 'menuName',
        children: 'listTreeMenus',
      },
      tempShow: false,
      allMenuId: '', // 菜单列表id
      checkStrictly: true,// 父子是否关联，默认不关联
    }
  },
  created() {
  },
  methods: {
    close() {
      this.data = []
      this.$emit('isShow', false)
    },
    open() {
      // console.log('------------------open')
      // this.data = []
      this.tempShow = this.isShow;
      let self = this
      this.allMenuId = this.haveID
      // console.log('propsKey=已选择节点：', this.propsKey)
      // console.log('haveID=全部节点：', this.haveID)
      if (this.setType == 'all') {
        // 超级管理员设置公司权限，列表展示全部 
        Api_SuperAdmin.menuList().then(res => {
          this.data = res.data.data
        })
      } else if (this.setType == 'superSetProject') {
        // 超级管理员设置项目权限 
        if (this.allMenuId) {
          this.allMenuId = this.allMenuId.split(',')
        }
        Api_SuperAdmin.getModules().then(res => {

          let allMenuArr = res.data.data
          // 平铺所有权限 
          let arr = {}
          allMenuArr.forEach(item => {
            arr[item.id] = item
            arr[item.id].listTreeMenus = []
          });
          // 获取所有权限的父级id以及当前id
          let allIds = []
          self.allMenuId.forEach(id => {
            allIds.push(id)
            if (arr[id].parentId != 0) {
              allIds.push(arr[id].parentId)
              if (arr[arr[id].parentId].parentId != 0) {
                allIds.push(arr[arr[id].parentId].parentId)
                if (arr[arr[arr[id].parentId].parentId].parentId != 0) {
                  allIds.push(arr[arr[arr[id].parentId].parentId].parentId)
                }
              }
            }
          });

          let arr2 = {}
          allIds.forEach(id => {
            if (!arr2[id]) {
              arr2[id] = arr[id]
            }
          });

          allIds = Array.from(new Set(allIds))

          allIds.forEach(id => {
            let item = arr2[id]
            if (item.parentId != 0 && arr2[item.parentId]) {
              arr2[item.parentId].listTreeMenus.push(item)
              arr2[item.parentId].listTreeMenus = [...new Set(arr2[item.parentId]
                .listTreeMenus)]
            }
          });
          let haveMenu = []
          for (let i in arr2) {
            haveMenu.push(arr2[i])
          }
          this.data = haveMenu.filter((item) => {
            return item.parentId == 0
          })
        })
      }
    },
    sure() {
      let arr = this.$refs.tree.getCheckedKeys()
      this.$emit('selectModules', arr)
    }
  }
}
</script>

<style>
</style>